import React, { useState, useEffect } from "react";
import { Dialog } from "./Dialog";
import { driveFileList, driveFileLoad } from "../data/GoogleDriveStorage";
import { loadFromBlob } from "../data/blob";
import { AppState, BinaryFiles, UIAppState } from "../types";

const CLIENT_ID = "341276552286-iermc2426jdr6mj61oa139c3ut25rm3t.apps.googleusercontent.com";

export const GoogleDriveLoadDialog = ({
  appState,
  onClose,
  onLoad,
}: {
  appState: UIAppState;
  onClose: () => void;
  onLoad: (elements: any, appState: any, files: any) => void;
}) => {
  const [fileList, setFileList] = useState<{ id: string; name: string }[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    driveFileList(CLIENT_ID)
      .then((files) => {
        setFileList(files);
        setIsLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setIsLoading(false);
      });
  }, []);

  const handleLoad = async (fileId: string) => {
    setIsLoading(true);
    try {
      const data = await driveFileLoad(CLIENT_ID, fileId);
      const blob = new Blob([JSON.stringify(data)], { type: "application/json" });
      const { elements, appState: loadedAppState, files } = await loadFromBlob(blob, appState as AppState, null);
      onLoad(elements, loadedAppState, files);
      onClose();
    } catch (e: any) {
      setError(e.message);
      setIsLoading(false);
    }
  };

  return (
    <Dialog onCloseRequest={onClose} title="Load from Google Drive" className="GoogleDriveLoadDialog">
      <div className="GoogleDriveLoadDialog__content" style={{ padding: "1rem" }}>
        {isLoading && <div>Loading...</div>}
        {error && <div style={{ color: "red" }}>Error: {error}</div>}
        {!isLoading && !error && (
          <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
            {fileList.map((file) => (
              <li key={file.id} style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>
                <button
                  type="button"
                  onClick={() => handleLoad(file.id)}
                  style={{ background: "none", border: "none", cursor: "pointer", width: "100%", textAlign: "left", fontSize: "1rem" }}
                >
                  {file.name}
                </button>
              </li>
            ))}
            {fileList.length === 0 && <li>No files found in .excalidraw folder.</li>}
          </ul>
        )}
      </div>
    </Dialog>
  );
};
